import { CheckCircle2, Clock, XCircle } from 'lucide-react'

type DnsStatus = 'pass' | 'fail' | 'pending'

interface DnsStatusIconProps {
  status: DnsStatus
}

export function DnsStatusIcon({ status }: DnsStatusIconProps): React.JSX.Element {
  if (status === 'pass') {
    return <CheckCircle2 className="h-4 w-4 text-green-500" />
  }
  if (status === 'fail') {
    return <XCircle className="h-4 w-4 text-red-500" />
  }
  return <Clock className="h-4 w-4 text-yellow-500" />
}
